import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { LocalidadesService } from '../../../../../service/localidades.service';
import { CreateLocalidadDto, Localidad, Point } from '../../../../../service/types/types';
import { GMapSelector } from '../../../../common/predios/GMapSelector';

type LocalidadForm = {
  name: string;
  location: Point;
};

type LocalidadProps = {
  onSave: (success: boolean) => void;
  localidad?: Localidad;
  isUpdate?: boolean;
};

export default function LocalidadModal({onSave, localidad, isUpdate}: LocalidadProps) {
  const [show, setShow] = useState(false);
  const { register, handleSubmit, setValue } = useForm<LocalidadForm>();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const onSubmit = async (data: LocalidadForm) => {
    const payload: CreateLocalidadDto = {
      ...data
    };
    try {
      if(localidad && isUpdate) await LocalidadesService.update(localidad.id, payload);
      else await LocalidadesService.create(payload) 
      onSave(true);
      handleClose();
    } catch (error){
      onSave(false);
      console.error('Error saving users:', error);
    }
  };

  return (
    <>
      {/* Botón para abrir el modal */}
      <Button variant={isUpdate ? "warning" : "primary"} onClick={handleShow}>
        {isUpdate ? "Editar" : "Crear Localiad"} 
      </Button>
      {/* Ventana emergente */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Nueva Localidad</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group className="mb-3">
              <Form.Label>Ubicación</Form.Label>
              <GMapSelector
                initialCenter={localidad?.location.coordinates}
                onSelect={(location) => {
                  setValue('location', location);
                }}
              />
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Label>Nombre</Form.Label>
              <Form.Control {...register('name')} placeholder="nombre" defaultValue={localidad?.name} />
            </Form.Group>

            <Button variant="success" type="submit">
              Guardar
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}